import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const Logout = ({ disconnect }) => {
  const navigate = useNavigate();

  useEffect(() => {
    disconnect();
    navigate("/");
  }, []);

  return <div></div>;
};
